export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4 17v2h10v-2zm0-8v2h16V9zm16 6v-2H4v2zM4 7h16V5H4z\"/>"
};